var elementToObserve = document.querySelector('.page-content');
if (elementToObserve != null) {
    const observer = new MutationObserver(function () {
        observer.disconnect();
        let max_width = 576;

        document.querySelectorAll('.snize-product-label.top-right + .snize-product-label.top-left', '.snize-product-label.top-left + .snize-product-label.down-right').forEach(ele => {
            if (ele.previousSibling.classList.contains('top-right')) {
                let width = ele.offsetWidth + 7;
                ele.previousSibling.style.setProperty('left', `${width}px`, 'important');
            }

            if (ele.nextSibling.classList.contains('down-right')) {
                if (window.innerWidth <= max_width) {
                    var eleHeight = ele.nextSibling.offsetHeight + 7;

                    ele.nextSibling.style.setProperty('top', `${eleHeight}px`, 'important');
                    ele.nextSibling.style.setProperty('left', `0px`, 'important');
                }
                else {
                    let widthForThirdEle = ele.previousSibling.offsetWidth + ele.offsetWidth + 14;
                    ele.nextSibling.style.setProperty('left', `${widthForThirdEle}px`, 'important');
                }
            }
        })


        document.querySelectorAll('.snize-product-label.top-right + .snize-product-label.down-right').forEach(ele => {
            if (ele.previousSibling.classList.contains('top-right')) {
                if (window.innerWidth <= max_width) {
                    var previousEleHeight = ele.previousSibling.offsetHeight + 7;

                    ele.previousSibling.style.setProperty('top', `${previousEleHeight}px`, 'important');
                    ele.previousSibling.style.setProperty('left', `0px`, 'important');
                }
                else {
                    let width = ele.offsetWidth + 7;
                    ele.previousSibling.style.setProperty('left', `${width}px`, 'important');
                }
            }
        })

        document.querySelectorAll('.snize-product-label.top-right + .snize-product-label.down-left', '.snize-product-label.down-left + .snize-product-label.down-right').forEach(ele => {
            if (ele.previousSibling.classList.contains('top-right')) {
                let width = ele.offsetWidth + 7;
                ele.previousSibling.style.setProperty('left', `${width}px`, 'important');
            }
            if (ele.nextSibling.classList.contains('down-right')) {
                if (window.innerWidth <= max_width) {
                    var nextEleHeight = ele.nextSibling.offsetHeight + 7;

                    ele.nextSibling.style.setProperty('top', `${nextEleHeight}px`, 'important');
                    ele.nextSibling.style.setProperty('left', `0px`, 'important');
                }
                else {
                    let widthForThirdEle = ele.previousSibling.offsetWidth + ele.offsetWidth + 14;
                    ele.nextSibling.style.setProperty('left', `${widthForThirdEle}px`, 'important');
                }
            }
        })
        document.querySelectorAll('.snize-product-label.top-left + .snize-product-label.down-left').forEach(ele => {
            let width = ele.previousSibling.offsetWidth + 7;
            ele.style.setProperty('left', `${width}px`, 'important')
        })
      document.querySelectorAll('.snize-product-label.top-left + .snize-product-label.down-right').forEach(ele => {
            let width = ele.previousSibling.offsetWidth + 7;
            ele.style.setProperty('left', `${width}px`, 'important')
        })
        document.querySelectorAll('.snize-product-label.down-left + .snize-product-label.down-right').forEach(ele => {
            let width = ele.previousSibling.offsetWidth + 7;
            ele.style.setProperty('left', `${width}px`, 'important')
        })

        setTimeout(function () {
            observer.observe(elementToObserve, { childList: true, subtree: true });
        }, 400);
    });
    observer.observe(elementToObserve, { childList: true, subtree: true });
}